// extracted by mini-css-extract-plugin
export var container = "_7h-0";
export var icon = "_7h-1";
export var text = "_7h-2";